import { Component, Input, HostBinding } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { JumbotronModel } from './jumbotron.model';

@Component({
  selector: 'wl-legacy-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: [
    './jumbotron.component.essent.scss',
    './jumbotron.component.ed.scss',
  ],
  standalone: true,
  imports: [NgStyle, NgClass, AutomationIdDirective],
})
export class JumbotronComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() items?: JumbotronModel;

  @HostBinding('class')
  class = '';
}
